import { lazy } from "react";
import WriteToHr from "../../../../Pages/Writetohr/WriteToHr";
import ShowAddIssue from "../../../../Pages/Writetohr/ShowAddIssue";
import BaseLocation from "../../../Common/Baselocation/BaseLocation";

const CoorinatorPage = lazy(
    () => import("../../../../Pages/CooridantorPannel/CoorinatorPage"),
);
const AccessControlAttendenceReport = lazy(
    () => import("../../../../Pages/DailyReport/AccessControlAttendenceReport"),
);
const MachineMisPunch = lazy(
    () => import("../../../../Pages/DailyReport/MachineMisPunch"),
);
const MissPunchReportDownload = lazy(
    () => import("../../../../Pages/DailyReport/MissPunchReportDownload"),
);

const TravelMisPunchMonthly = lazy(
    () => import("../../../../Pages/DailyReport/TravelMisPunchMonthly"),
);

// const Dashboard = lazy(() => import("../../Pages/Dashboard"));
const Dashboard = lazy(() => import("../../../../Pages/Dashboard/index"));
const EmployeeDashBoard = lazy(
    () => import("../../../../Pages/employeeApp/empDashboard/EmpDashboard"),
);
const HrDashboard = lazy(
    () => import("../../../../Pages/Dashboard/HRDashboard/HrDashboard"),
);
const DepartmentTable = lazy(
    () => import("../../../../Pages/ListOfDepartment"),
);
const ListofAllEmployee = lazy(
    () => import("../../../../Pages/ShowListOfAllEmployee"),
);
const OfficeTimePolicy = lazy(
    () => import("../../../../Pages/OfficeTimePolicy"),
);
const ListOfPolicyTable = lazy(
    () => import("../../../Common/ListOfPolicyTable/index"),
);
const ShiftDetails = lazy(() => import("../../../../Pages/ShiftDetails"));
const ShiftDetailsTable = lazy(
    () => import("../../../Common/ShiftDetailsTable"),
);
const EmployeeRegister = lazy(
    () => import("../../../../Pages/EmployeeRegisterForm"),
);
const EmployeeUpDateForm = lazy(
    () => import("../../../../Pages/UpDateEmployeeDetails"),
);
const EmployeeDetailsPage = lazy(
    () => import("../../../ShowParticularEmployeeDetails"),
);
const UpdateShiftDetails = lazy(
    () => import("../../../../Pages/UpDateShiftDetails"),
);
const UpdateOfficeTimePolicy = lazy(
    () => import("../../../../Pages/UpDateOfficeTimePolicy"),
);
const CompanyBranchTable = lazy(
    () => import("../../../../Pages/CompanyBranchtable"),
);
const ManualPunch = lazy(() => import("../../../../Pages/ManualPunch"));
const DailyReportPage = lazy(() => import("../../../../Pages/DailyReport"));
const ApproveForm = lazy(() => import("../../../../Pages/ApproveForm"));
const ShowJoiningData = lazy(() => import("../../../../Pages/ShowJoiningData"));
const ShowSingleJoiningData = lazy(
    () => import("../../../ShowSingleJoiningData"),
);
const MonthlyJoiningReport = lazy(
    () => import("../../../../Pages/MonthlyJoiningReport"),
);
const MonthlyResignationReport = lazy(
    () => import("../../../../Pages/MonthlyResignationReport"),
);
const JoiningPdf = lazy(() => import("../../../../Pages/JoiningPdf"));
const Degree = lazy(() => import("../../../../Pages/Degree"));
const JoiningForm = lazy(() => import("../../../../Pages/JoiningForm"));
const DuplicateAndInvalidempData = lazy(
    () => import("../../../../Pages/DuplicateAndInvalidEmployee"),
);
const LeaveRequest = lazy(
    () => import("../../../../Pages/LeaveRequest/leaveRequest"),
);
const Announcement = lazy(
    () => import("../../../../Pages/Announcement/Announcement"),
);
const ShowAnnoucement = lazy(
    () => import("../../../../Pages/Announcement/ShowAnnoucement"),
);
const AnnoucementForm = lazy(
    () => import("../../../../Pages/Announcement/AnnouncementForm"),
);
const SalaryReport = lazy(
    () => import("../../../../Pages/SalaryReport/SalaryReport"),
);
const AttendenceLogs = lazy(
    () => import("../../../../Pages/Attendence Logs/AttendenceLogs"),
);
const EmployeeData = lazy(
    () => import("../../../Common/showDashboardData/EmployeeData"),
);
const UpdateAttendenceLogs = lazy(
    () => import("../../../Common/DataLogs/DataLogs"),
);
const AssetMaster = lazy(
    () => import("../../../../Pages/AssetManagement/AssetMaster/index"),
);
const AssetMasterInfo = lazy(
    () =>
        import("../../../../Pages/AssetManagement/AssetMaster/AssetInfo/index"),
);
const EmployeeAssetsDetails = lazy(
    () =>
        import("../../../../Pages/AssetManagement/AssetAssignment/showAssignedAsset/index"),
);
const AssetAssignment = lazy(
    () => import("../../../../Pages/AssetManagement/index"),
);
// const AssetAssignment = lazy(() => import('../../../../Pages/AssetManagement/AssetAssignment/index'));

const HR = [
    { path: "dashboard", element: <Dashboard /> },
    { path: "Employee-Dashboard", element: <EmployeeDashBoard /> },
    { path: "hrdashboard", element: <HrDashboard /> },
    { path: "departmenttable", element: <DepartmentTable /> },
    { path: "listofallemployee", element: <ListofAllEmployee /> },
    { path: "officetimepolicytable", element: <OfficeTimePolicy /> },
    { path: "listofpolicytable", element: <ListOfPolicyTable /> },
    { path: "shiftdetails", element: <ShiftDetails /> },
    { path: "shiftdetailstable", element: <ShiftDetailsTable /> },
    { path: "Registrationform", element: <EmployeeRegister /> },
    { path: "employeeupdateform", element: <EmployeeUpDateForm /> },
    { path: "employeeDetails", element: <EmployeeDetailsPage /> },
    { path: "updateshiftdetails", element: <UpdateShiftDetails /> },
    { path: "updateofficytimepolicy", element: <UpdateOfficeTimePolicy /> },
    { path: "companybranchtable", element: <CompanyBranchTable /> },
    { path: "manualpunch", element: <ManualPunch /> },
    { path: "dailyreportcomponent", element: <DailyReportPage /> },
    { path: "approveForm", element: <ApproveForm /> },
    { path: "showJoiningData", element: <ShowJoiningData /> },
    { path: "showsinglejoiningData", element: <ShowSingleJoiningData /> },
    { path: "monthlyJoiningReport", element: <MonthlyJoiningReport /> },
    { path: "monthlyResignationReport", element: <MonthlyResignationReport /> },
    { path: "JoiningPdf", element: <JoiningPdf /> },
    { path: "degree", element: <Degree /> },
    { path: "joiningform", element: <JoiningForm /> },
    { path: "invalid-duplicate-data", element: <DuplicateAndInvalidempData /> },
    { path: "leave", element: <LeaveRequest /> },
    { path: "announcement", element: <Announcement /> },
    { path: "showAnnoucement", element: <ShowAnnoucement /> },
    { path: "addAnnouncement", element: <AnnoucementForm /> },
    { path: "updateAnnoucement", element: <AnnoucementForm /> },
    { path: "salaryReport", element: <SalaryReport /> },
    { path: "attendenceLogs", element: <AttendenceLogs /> },
    { path: "employeeData", element: <EmployeeData /> },
    { path: "logProcess", element: <UpdateAttendenceLogs /> },
    { path: "penaltyReport", element: <MissPunchReportDownload /> },
    { path: "monthlyTravelMisPunch", element: <TravelMisPunchMonthly /> },
    { path: "monthlyMachineMisPunch", element: <MachineMisPunch /> },
    { path: "coordinatorSupervision", element: <CoorinatorPage /> },
    { path: "accessControlReport", element: <AccessControlAttendenceReport /> },
    {
        path: "asset-assignment",
        element: <AssetAssignment />,
    },
    {
        path: "/layout/employee-assets/:employeeId",
        element: <EmployeeAssetsDetails />,
    },

    { path: "asset-master", element: <AssetMaster /> },
    { path: "asset-master/:assetId", element: <AssetMasterInfo /> },

    { path: "write-to-hr", element: <WriteToHr /> },
    { path: "show-issue", element: <ShowAddIssue /> },

    {
        path: "baselocation",
        element: <BaseLocation />,
    },
];

export default HR;
